module.exports = __webpack_public_path__ + "static/media/couple-over.a413060b.svg";